export enum ProductType {
  PDL = 'pdlLoans',
  ILSContract = 'ilsContracts',
  ILSApplication = 'ilsApplications',
}
